// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"ProductItemDetails_bottomBar__2kHIA","productLabel":"ProductItemDetails_productLabel__rTrNy"};